import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../components/utils/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(
    private snackbar: MatSnackBar
  ) { }


  showNotification(event:string, url:string, message:string, buttonName:string, persist:boolean = false){
    this.snackbar.openFromComponent(SnackbarComponent, {
      duration:persist ? 0 : 5*2000,
      data:{
        event:event,
        message:message,
        url:url,
        actionName:buttonName
      },
      horizontalPosition:this.horizontalPosition,
      verticalPosition:this.verticalPosition,
    });
  }
}
